import { render } from "./TextBoxWithFallback.vue?vue&type=template&id=42d7bb4c"
import script from "./TextBoxWithFallback.vue?vue&type=script&lang=js"
export * from "./TextBoxWithFallback.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__